<template>
  <!-- PC版本 -->
  <div v-if="!isMobile" id="fullpage">
    <div class="section video-section">
      <video ref="videoRef" :src="homeVideo" autoplay muted playsinline loop preload="auto" class="video"></video>
      <div class="video-text-overlay-line1 absolute text-white text-[2.5vw] w-45vw leading-[22px] sm:top-[22%] sm:left-[40px] sm:leading-[36px] md:top-[25%] md:left-[80px] md:leading-[48px] lg:top-[27%] lg:left-[120px] lg:leading-[58px] xl:top-[29%] xl:left-[150px] xl:leading-[62px] 2xl:top-[30%] 2xl:left-[180px] 2xl:leading-[70px] font-alibaba font-bold" style="line-height: 3.6vw">
        <p>{{ homeTexts.hero.title }}</p>
      </div>
    </div>

    <div class="section second-section h-screen">
      <el-row class="content-row">
        <el-col :span="12">
          <div class="box">
            <img src="@/assets/map.png" class="large-image" />
            <img v-for="(img, index) in smallImages" :key="index" :src="img.src"
              class="small-image hidden-before-animate" :style="img.style" />
          </div>
        </el-col>

        <el-col :span="12" class="flex flex-col items-center justify-cente pt-5vw pb-5vw">
          <div class="who-we-are-container opacity-0 animate-none">
            <h1 class="title flex flex-row items-end whitespace-nowrap">
              <span class="font-alibaba font-bold text-[4.5vw] sm:text-[5.6vw] text-[#ff8c00] flex items-end pb-[-1vw]">
                {{ homeTexts.whoWeAre.title.who }}
              </span>
              <span class="font-alibaba font-bold ml-1vw text-white flex items-end ml-2 text-[3.2vw] sm:text-[4vw]">
                {{ homeTexts.whoWeAre.title.weAre }}
              </span>
            </h1>
            <p class="mt-4 text-white text-1.4vw leading-[1.4]">
              <span class="font-bold text-[#ff8c00] font-alibaba">Creston Group</span>
              {{ homeTexts.whoWeAre.description }}
            </p>
            <ul class="list-disc list-inside text-white text-1.4vw mt-4 space-y-2 leading-[1.4] font-alibaba">
              <li>
                <strong>{{ homeTexts.whoWeAre.bulletPoints.deliver.title }}</strong>
                {{ homeTexts.whoWeAre.bulletPoints.deliver.content }}
              </li>
              <li>
                <strong>{{ homeTexts.whoWeAre.bulletPoints.grow.title }}</strong>
                {{ homeTexts.whoWeAre.bulletPoints.grow.content }}
              </li>
              <li>
                <strong>{{ homeTexts.whoWeAre.bulletPoints.last.title }}</strong>
                {{ homeTexts.whoWeAre.bulletPoints.last.content }}
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="section third-section">
      <img src="@/assets/care.png" class="third-car" />
      <div class="one-car">
        <div class="relative bg-[#0a0a7a] text-white p-4 rounded-2xl max-w-md">
          <!-- 标题 -->
          <h2 class="text-1.8vw font-bold mb-2">{{ homeTexts.offerings.sourcingFromChina.title }}</h2>
          <!-- 描述 -->
          <p class="text-1.1vw leading-[1.3]">
            {{ homeTexts.offerings.sourcingFromChina.description }}
          </p>
          <!-- 气泡小三角 -->
          <div
            class="absolute left-1/2 -bottom-3 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-12 border-l-transparent border-r-transparent border-t-[#0a0a7a]">
          </div>
        </div>
      </div>
      <div class="two-car">
        <div class="relative bg-[#ffffff] text-black p-4 rounded-2xl w-full flex flex-col justify-center">
          <div class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full">
            <div
              class="w-0 h-0 border-l-[0.6vw] border-l-transparent border-r-[0.6vw] border-r-transparent border-b-[1.2vw] border-b-[#ffffff]">
            </div>
          </div>
          <!-- 标题 -->
          <h2 class="text-1.3vw font-bold mb-2">{{ homeTexts.offerings.engineeringSupport.title }}</h2>
        </div>
      </div>
      <div class="five-car">
        <div class="relative bg-[#ffffff] text-black p-4 rounded-2xl w-full flex flex-col justify-center">
          <div class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full">
            <div
              class="w-0 h-0 border-l-[0.6vw] border-l-transparent border-r-[0.6vw] border-r-transparent border-b-[1.2vw] border-b-[#ffffff]">
            </div>
          </div>
          <!-- 标题 -->
          <h2 class="text-1.3vw font-bold mb-2">{{ homeTexts.offerings.aftermarketServices.title }}</h2>
        </div>
      </div>
      <div class="three-car">
        <div class="relative inline-block min-w-[220px] w-[38vw] max-w-2xl">
          <div class="bg-[#1e2a78] text-white rounded-[1.5vw] p-[1vw] shadow-lg">
            <h2 class="text-[1.8vw] font-bold mb-[1vw]">
              {{ homeTexts.offerings.salesServiceRepresentation.title }}
            </h2>
            <p class="text-[1.1vw] text-gray-200 leading-[1.3]">
              {{ homeTexts.offerings.salesServiceRepresentation.description }}
            </p>
          </div>
          <div class="absolute bottom-0 left-3/5 transform -translate-x-1/2 translate-y-full">
            <div class="w-0 h-0
                    border-l-[0.6vw] border-l-transparent
                    border-r-[0.6vw] border-r-transparent
                    border-t-[1vw] border-t-[#1e2a78]">
            </div>
          </div>
        </div>
      </div>
      <div class="title-car">
        <h1 class="flex items-end font-bold whitespace-nowrap w-auto min-w-[20vw] max-w-[50vw]">
          <span class="text-[#ff8c00] mr-2 text-[2.4vw] sm:text-[2.8vw] md:text-[3.2vw]">{{ homeTexts.offerings.title.what }}</span>
          <span class="text-black mt-1vw text-[2.0vw] sm:text-[2.4vw] md:text-[2.8vw]">{{ homeTexts.offerings.title.weOffer }}</span>
        </h1>
      </div>
      <div class="four-car">
        <div class="relative inline-block">
          <!-- 三角形箭头 -->
          <div class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full">
            <div
              class="w-0 h-0 border-l-[0.6vw] border-l-transparent border-r-[0.6vw] border-r-transparent border-b-[1.2vw] border-b-[#f59e0b]">
            </div>
          </div>

          <!-- 主体内容框 -->
          <div class="bg-[#f59e0b] text-black rounded-1.2vw p-6 w-[26vw] shadow-md">
            <p class="font-bold text-1.8vw mb-2">{{ homeTexts.offerings.integratedLogistics.title }}</p>
            <p class="text-1.1vw leading-[1.3]">
              {{ homeTexts.offerings.integratedLogistics.description }}
            </p>
          </div>
        </div>
      </div>
  
    </div>
    <div class="section foot-section">
      <FooterForHome v-if="!isMobile" />
      <MobileFooter v-if="isMobile" />
    </div>
  </div>
  
  <!-- Mobile版本 -->
  <MobileHome v-else />
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { onMounted, onBeforeUnmount, nextTick, ref, computed } from "vue";
import fullpage from "fullpage.js";
import "fullpage.js/dist/fullpage.css";
import FooterForHome from "../components/FooterForHome.vue";
import { pushToDataLayer } from "../utils/gtm"; // 替换 gtag 引用
import { useChatWidget } from "../utils/chatWidget";
import homeVideo from "@/assets/home.mp4";
import { generateSmallImages } from "../utils/imageData";
import { useDeviceDetection } from "@/utils/deviceDetection";
import MobileHome from "../components/MobileHome.vue";
const router = useRouter();

const { isMobile } = useDeviceDetection();

const dotSrc = new URL("@/assets/map_dot.png", import.meta.url).href;
const videoRef = ref(null);

import { useHead } from "@vueuse/head";
import { useI18n } from 'vue-i18n';
import { getSEO } from '../utils/seoConfig';

const { locale, messages } = useI18n() // 移除 t

// 获取首页文本
const homeTexts = computed(() => {
  return messages.value[locale.value]?.home || {
    hero: { title: 'Default Title' },
    offerings: {
      title: {
        what: 'What',
        weOffer: 'We Offer'
      }
    }
  };
});

// 动态多语言 SEO
const seo = computed(() => getSEO(locale.value, 'home'));

useHead({
  title: computed(() => seo.value.title),
  meta: [
    { name: "description", content: computed(() => seo.value.description) },
    { name: "keywords", content: computed(() => seo.value.keywords) },
    { property: "og:title", content: computed(() => seo.value.title) },
    { property: "og:description", content: computed(() => seo.value.description) },
  ],
});

const smallImages = generateSmallImages(dotSrc);

let fullpageInstance: any;

const { openChat } = useChatWidget();

const goToContactUs = () => {
  openChat("Home");
  pushToDataLayer("Chat_With_Us", {
    category: "Home",
    label: "Chat With Us",
  });
};

function getRandomDelay(min = 0.1, max = 1): string {
  const delay = Math.random() * (max - min) + min;
  return delay.toFixed(1) + "s";
}

onMounted(() => {
  pushToDataLayer('page_view', {
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: document.referrer,
  });

  nextTick(() => {
    // Ensure DOM is ready before fullpage.js initializes
    fullpageInstance = new fullpage("#fullpage", {
      autoScrolling: true,
      navigation: true,
      scrollingSpeed: 700,
      // licenseKey: 'YOUR_LICENSE_KEY_HERE', // 如果需要的话
      afterLoad: function (origin, destination, direction) {
        const currentSection = destination.item;

        // Add .animate class to elements in the current section
        if (destination.index === 0) {
          // Video Section
          currentSection
            .querySelectorAll(".video-text-overlay-line1")
            .forEach((el) => el.classList.add("animate"));
        } else if (destination.index === 1) {
          // Second Section
          currentSection
            .querySelectorAll(".small-image")
            .forEach((el) => el.classList.add("animate"));
          const whoWeAreEl = currentSection.querySelector(
            ".who-we-are-container"
          );
          if (whoWeAreEl) {
            whoWeAreEl.classList.add("animate");
          }
        } else if (destination.index === 2) {
          // Third Section
          currentSection
            .querySelectorAll(
              ".title-car, .one-car, .third-car, .two-car, .three-car, .four-car, .five-car"
            )
            .forEach((el) => el.classList.add("animate"));
        }
      },
    });
    
    // 将 fullpage 实例暴露到全局

  });
});

onBeforeUnmount(() => {
  if (fullpageInstance) {
    fullpageInstance.destroy("all");
  }
});
//just for safari begin
const tryPlayVideo = () => {
  const video = videoRef.value;
  if (video && video.paused) {
    video.play().catch((e) => console.warn("User interaction play failed:", e));
  }
};
window.addEventListener("touchstart", tryPlayVideo, { once: true });
window.addEventListener("click", tryPlayVideo, { once: true });
//just for safari end
</script>

<style scoped>
#fullpage,
.section {
  width: 100%;
}

.section {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* --- First Section --- */
.video-section {
  position: relative;
}

.video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  display: block;
}

.video-text-overlay-line1 {
  opacity: 0;
  animation-fill-mode: forwards;
}

.inquery {
  position: absolute;
  right: 10px;
  top: 32%;
  z-index: 100;
  width: 5%;
  /* 可以根据需要调整大小 */
}

.video-text-overlay-line1.animate {
  animation: fadeInUp 1s ease-out 0.3s forwards;
}

.video-text-overlay-line2.animate {
  animation: fadeInUp 1s ease-out 0.8s forwards;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Second Section --- */
.second-section {
  background: linear-gradient(180deg, #010204 0%, #0d0971 100%);
}

.box {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 24px;
  width: 1480px;
}

.large-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.small-image {
  position: absolute;
  width: 20px;
  height: 30px;
  object-fit: contain;
  transition: transform 0.7s;
  /* For hover */
  opacity: 0;
  /* Initial state */
  animation-fill-mode: forwards;
}

.small-image.animate {
  animation-name: smallImageAnimation;
  animation-duration: 1.5s;
  animation-timing-function: ease;
  /* animation-delay comes from inline style */
  animation-fill-mode: forwards;
}

@keyframes smallImageAnimation {
  0% {
    opacity: 0;
    transform: translateY(40px) scale(1);
  }

  40% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }

  70% {
    opacity: 1;
    transform: translateY(0) scale(1.2);
  }

  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.small-image:hover {
  transform: scale(1.2);
}

.who-we-are-container {
  margin-top: 4%;
  margin-left: 15%;
  width: 73%;
  opacity: 0;
  /* Initial state for animation */
  animation-fill-mode: forwards;
}

.who-we-are-container.animate {
  animation: whoWeAreEntrance 1s ease-out 0.5s forwards;
}

@keyframes whoWeAreEntrance {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  display: flex;
  flex-direction: row;
  max-width: 100%;
}

.title-who {
  color: #ff8c00;
}

@media screen and (max-width: 1440px) {
  .title-we-are {
    display: flex;
    margin-left: 10px;
  }
}

@media screen and (max-width: 1920px) {
  .title-we-are {
    color: #ffffff;
    font-size: 7.6vh;
    display: flex;
    margin-left: 10px;
    align-items: flex-end;
  }
}

@media screen and (max-width: 2560px) {
  .title-we-are {
    color: #ffffff;
    font-size: 7.6vh;
    display: flex;
    margin-left: 10px;
    align-items: flex-end;
  }
}

.title-we-are {
  color: #ffffff;
  font-size: 7.6vh;
  display: flex;
  margin-left: 10px;
  align-items: flex-end;
}

.box-text {
  display: flex;
  flex-direction: column;
}

/* --- Third Section --- */
.third-section {
  background-image: url("@/assets/bg_offer.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: rgb(245, 248, 255);
}

.title-car,
.one-car,
.third-car,
.two-car,
.three-car,
.four-car,
.five-car {
  position: absolute;
  height: auto;
  opacity: 0;
  /* Initial state */
  animation-fill-mode: forwards;
}

.title-car {
  left: 12%;
  top: 8%;
  width: 25%;
}

.one-car {
  left: 12%;
  top: 25%;
  width: 25%;
}

.third-car {
  left: 36%;
  top: 44%;
  width: 32%;
}

.two-car {
  left: 14%;
  top: 70%;
  width: 16%;
}

.three-car {
  left: 53.5%;
  top: 22%;
  width: 36%;
}

.four-car {
  left: 38%;
  top: 75%;
  width: 22%;
}

.five-car {
  left: 72%;
  top: 69%;
  width: 16%;
}

.title-car.animate {
  animation: fadeInUp 1s ease-out 0.1s forwards;
}

.one-car.animate {
  animation: fadeInUp 1s ease-out 0.2s forwards;
}

.two-car.animate {
  animation: fadeInUp 1s ease-out 0.4s forwards;
}

.three-car.animate {
  animation: fadeInUp 1s ease-out 0.6s forwards;
}

.four-car.animate {
  animation: fadeInUp 1s ease-out 0.8s forwards;
}

.five-car.animate {
  animation: fadeInUp 1s ease-out 1s forwards;
}

.third-car.animate {
  animation: fadeInLeftToRight 1.2s ease-out 0.3s forwards;
}

@keyframes fadeInLeftToRight {
  from {
    opacity: 0;
    transform: translateX(-80px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.foot-section {
  height: 46vh;
  /* 只占视口高度的 30% */
  background-color: #0d0971;
  color: rgb(255, 255, 255);
  border-top-left-radius: 100px;
  /* 左上角圆角 */
  border-top-right-radius: 100px;
  /* 右上角圆角 */
}

@layer utilities {
  @keyframes fadeInForwards {
    to {
      opacity: 1;
    }
  }

  .animate-fade-in {
    animation: fadeInForwards 1s ease forwards;
  }
}
</style>
